module.exports = __webpack_public_path__ + "static/img/drag-vertical.3c2bdb18.svg";